
{
  "familyId": "SPR-LEEN-ENGELS",
  "questions": [
    {
      "id": "SPR-LEEN-ENGELS-001",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je het Engelse leenwoord voor 'groep'?",
      "context": null,
      "options": ["team", "tiem", "teem", "taim"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse leenwoorden", "content": "Engelse leenwoorden behouden hun Engelse spelling: team (met ea). Je schrijft het niet zoals je het in het Nederlands zou spellen (tiem).", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_team",
      "variantIndex": 1,
      "feedback": { "explanationText": "Dit is een Engels leenwoord en behoudt de Engelse spelling: team (met ea). Je schrijft het niet zoals je het in het Nederlands zou spellen.", "distractorExplanations": { "0": "Correct! Engelse leenwoorden behouden hun spelling: team.", "1": "Fout: dit is de Nederlandse fonetische spelling. De Engelse spelling is team.", "2": "Fout: je schrijft ea, niet ee. De Engelse spelling is team.", "3": "Fout: dit is hoe je het misschien hoort, maar de Engelse spelling is team." } }
    },
    {
      "id": "SPR-LEEN-ENGELS-002",
      "familyId": "SPR-LEEN-ENGELS",
      "module": "SpellingRegel",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels",
      "questionType": "multiple_choice",
      "question": "Welk woord is juist geschreven?",
      "context": null,
      "options": ["computer", "kompjoeter", "compjoeter", "komputer"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse spelling behouden", "content": "Het woord 'computer' is Engels en behoudt de Engelse spelling met c, o, u. Je schrijft het niet zoals je het hoort in het Nederlands.", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_computer",
      "variantIndex": 2,
      "feedback": { "explanationText": "Dit is een Engels leenwoord: computer (met c en u). Je schrijft het niet zoals je het in het Nederlands zou spellen (kompjoeter).", "distractorExplanations": { "0": "Correct! Engelse spelling: computer.", "1": "Fout: dit is fonetisch Nederlands. De Engelse spelling is computer.", "2": "Fout: je schrijft c, niet k. En je schrijft u, niet oe. Het is computer.", "3": "Fout: je schrijft c, niet k. De Engelse spelling is computer." } }
    }
  ]
}
